import { MeasurementType } from "./measurement-type";
import { Device } from "./device";
import {DefaultMeasurementType} from "./default-measurement-type";

export class DeviceMeasurement {
  description: string;
  alias: string;
  name: string;
  derived: number;
  sampleRate: number;
  dateLastValueReported: number;
  lastValueReported: string;
  displayInAsset: boolean;
  measurementType: MeasurementType | DefaultMeasurementType;
  device: Device;
  uuid: string;
  expression: string;
}
